import { render, staticRenderFns } from "./index5.vue?vue&type=template&id=2d6e777c"
import script from "./index5.vue?vue&type=script&lang=js"
export * from "./index5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports